/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from '@/axios/api';
import { definitions } from '@/types/api';
import { message } from 'ant-design-vue';
import {
  computed,
  ComputedRef,
  reactive, Ref, ref, toRaw, UnwrapRef,
} from 'vue';
import {
  Router,
  useRouter,
} from 'vue-router';
import validate, { ValidateRuleI } from '@/lib/validate';
import { cloneDeep } from '@/lib';
import { caseModuleArr } from '@/interface/case.interface';
import { BasicInfoFormState } from './interface';
import { CustomCaseClass } from '../js/case';

// TODO 案例单元不可修改或修改后删除所有关联数据,待后端处理
// 案例模块列表
const caseModules = ref(cloneDeep(caseModuleArr));

// 案例单元
const caseUnits = ref(['风险分析研判', '推演对象分析', '情景任务清单', '应急能力评估', '推演方案评估', '推演方案制定', '推演结果复盘', '应急预案优化']);

const caseUnitMarks = caseUnits.value.map((d, i) => reactive({ [i + 1]: d }));

const caseUnitFormatter = (n: number) => {
  try {
    return caseUnits.value[n];
  } catch (e) {
    return '';
  }
};
export {
  caseModules,
  caseUnits,
  caseUnitMarks,
  caseUnitFormatter,
};

export class BasicInfo {
  // 基本信息表单
  formState!: UnwrapRef<BasicInfoFormState>

  rules: ValidateRuleI = reactive({
    caseName: [{ required: true, message: '请输入案例名称' }],
    caseModule: [{ required: true, message: '请选择案例模块' }],
    caseInfomation: [{ required: true, message: '请输入案例信息' }],
    caseImg: [{ message: '请上传案例封面', required: true }],
  })

  // 已选中的单元数组
  selectedUnits!: ComputedRef;

  caseId!: Ref<string>;

  // 保存中
  saving = ref(false);

  caseDifficulty!: number;

  quering = ref(false);

  constructor(caseId: string) {
    this.caseId = ref(caseId);

    this.formState = reactive({
      id: '',
      caseName: '',
      caseInfomation: '',
      caseImg: '',
      caseModule: '',
      caseUnit: [0, 0],
      caseDifficulty: 5,
    });

    this.caseDifficulty = computed(() => this.formState.caseDifficulty / 2) as unknown as number;

    this.selectedUnits = computed(() => caseUnits.value.filter((d, index) => index >= this.formState.caseUnit[0] && index <= this.formState.caseUnit[1]));
    if (caseId) this.queryBasicInfo(this.caseId.value as string);
  }

  setCaseDifficulty(number: number) {
    this.formState.caseDifficulty = number * 2;
  }

  async queryBasicInfo(id: string = this.caseId.value) {
    try {
      this.quering.value = true;
      const { data } = await axios.queryCustomCaseById(id);
      if (data.success) {
        data.data.caseUnit = JSON.parse(data.data.caseUnit);
        data.data.caseUnit = ref([data.data.caseUnit.shift(), data.data.caseUnit.pop()]);
        Object.assign(this.formState, reactive(data.data));

        const CustomCase = CustomCaseClass.getInstance('basicInfo'); // 用来同步的数据
        CustomCase.caseInfo = {
          caseId: data.data.id as string,
          caseName: data.data.caseName,
          caseUnit: toRaw(data.data.caseUnit.value),
          caseModule: data.data.caseModule,
          caseDifficulty: data.data.caseDifficulty,
          caseInfomation: data.data.caseInfomation,
        };
        console.log(CustomCase, 'CustomCase');
        // this.formState = data.data;
      } else {
        message.error(data.message);
      }
      return data;
    } catch (e) {
      return new Error(e);
    } finally {
      this.quering.value = false;
    }
  }

  async uploadImg(formData: FormData) {
    try {
      const { data } = await axios.uploadImg(formData);
      if (data.success) {
        this.formState.caseImg = data.data;
      } else {
        message.error(data.message);
      }
      return data;
    } catch (e) {
      return new Error(e);
    }
  }

  async save(router: Router) {
    try {
      this.saving.value = true;
      const clone: definitions['CustomCase'] = JSON.parse(JSON.stringify(this.formState));
      if (!clone.id) delete clone.id;
      delete clone.createDate;
      const tmpUnit = [];
      // eslint-disable-next-line no-plusplus
      for (let i = (clone as any).caseUnit[0] as number; i <= (clone as any).caseUnit[1]; i++) {
        tmpUnit.push(i);
      }
      clone.caseUnit = JSON.stringify(tmpUnit);
      const { data } = await axios.editCustomCase(clone);
      if (data.success) {
        message.success('保存成功');
        this.caseId.value = data.data.id;
        await this.queryBasicInfo(this.caseId.value);
        router.replace(`/Teacher/customCase/edit/${this.caseId.value}`);
      } else {
        message.error(data.message);
      }
      return data;
    } catch (e) {
      return new Error(e);
    } finally {
      this.saving.value = false;
    }
  }
}

export class BasicInfoController {
  basicInfo!: BasicInfo

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  route!: any;

  router!: Router;

  emit: Function;

  constructor(basicInfo: BasicInfo, emit: Function) {
    this.basicInfo = basicInfo;
    this.router = useRouter();
    this.route = useRouter().currentRoute.value;
    this.emit = emit;
  }

  handleCaseUnitChange(arr: number[]) {
    this.basicInfo.formState.caseUnit = arr;
  }

  handleImgUpload(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    this.basicInfo.uploadImg(formData);
  }

  async handleSave() {
    // 验证，保存
    try {
      validate(this.basicInfo.formState, this.basicInfo.rules);
      await this.basicInfo.save(this.router);
    } catch (e) {
      throw new Error(e);
    }
  }

  handleNext() {
    validate(this.basicInfo.formState, this.basicInfo.rules);
    if (this.basicInfo.caseId.value) {
      this.emit('next');
    } else {
      message.info('请先保存案例信息');
    }
  }
}
